import { seriesColorMap, seriesOptionsMap } from "../../components/chart-series/series-options.values"
import { ChartType } from "./chart-type.enum"
import { isCustomSeries, Series, seriesDefinitionsMap, SeriesTypeEnum } from "../series"
import { TimeRange } from "../time-range.enum"
import { ChartTypeOptionsMap, getTimeRanges } from "../../options/lightweight-charts/chart-type-options.map"

export class Chart {
  constructor(
    public type: ChartType,
    public seriesType: SeriesTypeEnum,
    public timeRange: TimeRange,
    public description: string = '',
    public source: string = '',
    public series: Array<Series> = [],
  ) { }

  get chartOptions() { return ChartTypeOptionsMap.get(this.type)! }
  get timeRanges() { return getTimeRanges(this.type) }
  get seriesDefinitions() { return seriesDefinitionsMap.get(this.seriesType)! }
  get seriesOptions() { return seriesOptionsMap.get(this.seriesType)! }
  get seriesColors() {
    return seriesColorMap.get(this.seriesType)!.list
  }

  get isSingleSeries() { return this.series.length === 1 }
  get isCustomSeries() { return isCustomSeries(this.seriesDefinitions) }

  public sortSeriesByMax() {
    this.series.sort((a, b) => b.max - a.max)
  }
}

